import React, { ReactNode, useCallback, useMemo } from 'react'
import { useNavigation } from '@react-navigation/native'
import { ViewStyle } from 'react-native'
import { NavigationContainer } from '@src/screens/Common/containers'
import { AccountAvatar } from '@src/components/AccountAvatar'
import { NavigationBarProps } from '@src/components/navigationBar/NavigationBar'
import { useWebPresentationModeLogoutIcon } from '@src/hooks/useWebPresentationModeLogoutIcon'

interface AccountAvatarNavigationBarProps {
  children: ReactNode | ReactNode[]
  title?: string | ReactNode
  hideLeftIcon?: boolean
  rightAccessories?: NavigationBarProps['rightAccessories']
  style?: ViewStyle
  navigationBarProps?: Omit<NavigationBarProps, 'setHeaderHeight'>
}

export const AccountAvatarNavigationBar = ({
  children,
  title,
  hideLeftIcon,
  rightAccessories,
  style,
  navigationBarProps,
}: AccountAvatarNavigationBarProps) => {
  const navigation = useNavigation()
  const webPresentationModeLogoutIcon = useWebPresentationModeLogoutIcon()

  const goBack = useCallback(() => {
    navigation.navigate('Account')
  }, [navigation])

  const leftIcon = useMemo(() => {
    if (hideLeftIcon) {
      return undefined
    }
    return webPresentationModeLogoutIcon || <AccountAvatar />
  }, [hideLeftIcon, webPresentationModeLogoutIcon])

  return (
    <NavigationContainer
      title={title}
      rightAccessories={rightAccessories}
      style={style}
      navigationBarProps={navigationBarProps}
      allowBackNavigation={!hideLeftIcon}
      leftIcon={leftIcon}
      goBack={goBack}
    >
      {children}
    </NavigationContainer>
  )
}
